import { FulfillmentOrderStatus, Status } from '@vendasta/sales-orders';
import { FilterGroup, SelectFilterControl } from '@vendasta/va-filter2';
import { ExportToCSVRequest, ExportToCSVService, LoadRequest, TableDataService } from '@vendasta/va-filter2-table';
import { Observable } from 'rxjs';

export interface SalesOrdersTableOptions {
  forcedFilters?: ForcedFilterOptions;
  exportOptions?: RequestedExportType;
}

export enum RequestedExportType {
  Buyer,
  Sales,
  Partner,
}

// Any value will always be filtered on and the associated selector will be hidden
export interface ForcedFilterOptions {
  marketIds?: string[];
  salespersonId?: string;
  businessId?: string;
}

export const SALES_ORDERS_TABLE_FACTORY_PARAM_TOKEN = 'SALES_ORDERS_TABLE_FACTORY_PARAM_TOKEN';
export interface SalesOrdersTableFactoryParams {
  showActions: boolean;
  inBusinessCenter: boolean;
}

export interface OrdersRow {
  orderId: string;
  salespersonId: string;
  salesperson: SalesOrderSalesperson;
  partnerId: string;
  businessId: string;
  marketId: string;
  status: Status;
  requestedActivation: Date;
  created: Date;
  tags: string[];
  business: Business;
  contractDurationInMonths?: number;
  expiryDate?: Date;
  fulfillmentOrderStatus?: FulfillmentOrderStatus;
  hasFulfillment?: boolean;
}

export interface Business {
  companyName: string;
  address: string;
  address2: string;
  city: string;
  country: string;
  state: string;
  zip: string;
  phoneNumber: string;
  website: string;
  deleted: boolean;
}

export interface Market {
  name: string;
  marketId: string;
}

export interface Salesperson {
  salespersonId: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface SalesOrderSalesperson {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface Salesteam {
  id: string;
  teamName: string;
}

export enum exportDataFormatModalOption {
  ORDERS_PER_ROW = 'orders-per-row',
  PRODUCTS_PER_ROW = 'products-per-row',
}

export abstract class BaseSalesOrdersTableFilterService {
  filters: FilterGroup;
  marketFilterControl?: SelectFilterControl;
  packageFilterSectionName?: string;

  abstract initialize(forcedFilterOptions: ForcedFilterOptions, canAccessSalesTeams?: boolean): void;
}

export abstract class BaseSalesOrdersTableService implements TableDataService<OrdersRow> {
  totalResults$: Observable<number>;
  stats$?: Observable<{ [key: string]: number }>;
  presetViews?: string;

  abstract load(request: LoadRequest): Observable<OrdersRow[]>;
  abstract initialize(forcedFilterOptions: ForcedFilterOptions): void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export abstract class BaseSalesOrdersExportAllService<T> implements ExportToCSVService<OrdersRow> {
  abstract exportAllRowsToCSV(request: ExportToCSVRequest, option?: string): void;
  abstract initialize(forcedFilterOptions: ForcedFilterOptions, exportOptions: RequestedExportType): void;
}
